import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TaxParams, BruttoNettoYear } from '../../models/tax-params.model';

@Injectable({ providedIn: 'root' })
export class TaxDataService {
  constructor(private http: HttpClient) {}

  /**
   * Load the list of available calculation years.
   */
  getBruttoNettoYears(): Observable<BruttoNettoYear[]> {
    return this.http.get<BruttoNettoYear[]>('assets/brutto-netto/brutto-netto-years.json');
  }

  /**
   * Load tax parameters for a given year.
   */
  getTaxParams(year: number): Observable<TaxParams> {
    return this.http.get<TaxParams>(`assets/brutto-netto/${year}/tax-params.json`);
  }
}
